import React, {Fragment} from 'react';

import { processResponse } from '../../../utilities/processResponse';

import './Section.css';

const completionNoticeSection = (props) => {

    return (
        <Fragment>
            <div className={`${props.className} _CompletedNoticeSection`}
                dangerouslySetInnerHTML={{__html: processResponse(props.html)}}
            ></div>
        </Fragment>

    );
}

export default completionNoticeSection;
